import { render, staticRenderFns } from "./LegacyAlert.vue?vue&type=template&id=4a6a44be&scoped=true&"
import script from "./LegacyAlert.vue?vue&type=script&lang=js&"
export * from "./LegacyAlert.vue?vue&type=script&lang=js&"
import style0 from "./LegacyAlert.vue?vue&type=style&index=0&id=4a6a44be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6a44be",
  null
  
)

export default component.exports